// extracted by mini-css-extract-plugin
module.exports = {"categoryList":"Categories_categoryList__3DJnG","categoryItem":"Categories_categoryItem__22h-w"};